<template>
	<div>
		<v-dialog v-model="moveFieldDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Re-Order Field</v-subheader>
	        	</v-card-title>

	        	<v-divider></v-divider>

		        <v-card-text full-height nopadding>

		        	<v-list nopadding>
						<SlickList lockAxis="y" :useDragHandle="true" v-model="fieldItems">
					        <SlickItem v-for="(item, index) in fieldItems" :index="index" :key="index" style="z-index:9999">
					          	<v-list-tile>

					          	  <v-list-tile-content>
					          	    <v-list-tile-title>{{index+1}}.&nbsp;{{item.name}}</v-list-tile-title>
					          	  </v-list-tile-content>

					          	  <v-list-tile-action v-handle class="handle">
					          	    <v-icon>reorder</v-icon>
					          	  </v-list-tile-action>

					          	</v-list-tile>
					        </SlickItem>
				      	</SlickList>
					</v-list>

		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_saveOrder(fieldItems)">Ok</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';

	export default{
		directives: { handle: HandleDirective },
		data(){
			return{
				moveFieldDialog:false,
				fieldItems:null
			}
		},
		components:{
			SlickItem,
    		SlickList
		},
		methods:{
			openDialogWeb: function () {
				this.fieldItems = JSON.parse(JSON.stringify(this.$parent.Form.printTemplateFields));
				this.moveFieldDialog = true;
			},
			closeDialogWeb: function () {
				this.moveFieldDialog = false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/print_templates/dialogs/dialog_reorder.vue